document.addEventListener('click', function (e) {
  // Busca si el click ocurrió dentro de una card de producto
  const card = e.target.closest('.shop-card.product-item[data-product-url]');
  if (!card) return;

  // Solo queremos que el click sobre la ZONA DE IMAGEN navegue
  const media = e.target.closest('.dz-media-wrapper, .dz-media, .product-image, .hover-img');
  if (!media) return;

  // Si el click fue en elementos interactivos, NO navegues
  const interactive = e.target.closest(
    'a, button, add-to-cart, quick-view-modal, wishlist-btn, [data-dz-modal], input, label, select, textarea'
  );
  if (interactive) return;

  const url = card.getAttribute('data-product-url');
  if (url) window.location.href = url;
});